<template>
<div class="StepOne">
        <div class="item-card">
            <div class="page-module animated fadeInUp">
                <p class="name">企业估值用途</p>
                <ul>
                    <li v-for="(item, index) in cardOne" :key="index">
                        <!-- <div :class="{'card': true, 'active': activeCardOne == item.innerid}" @click="activeCardOne = item.innerid"> -->
                        <div :class="{'card': true, 'active': activeCardOne == item.innerid}" @click="selectActiveCardOne(item.innerid)">
                            <div class="head">
                                <p>{{item.title}}</p>
                                <p>{{item.twoLeverTitle}}</p>
                                <img :src="item.img" alt="icon">
                            </div>
                            <div class="msg">
                                <p>{{item.msg}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bg-F5F7FA item-card hy">
            <div class="page-module animated fadeInUp">
                <p class="name">企业所属行业</p>
                <ul>
                    <li v-for="(item, index) in cardTwo" :key="index">
                        <!-- <div :class="{'card': true, 'active': activeCardTwo == item.innerid}" @click="activeCardTwo = item.innerid"> -->
                        <div :class="{'card': true, 'active': activeCardTwo == item.innerid}" @click="selectActiveCardTwo(item.innerid)">
                            <img :src="item.img" alt="icon">
                            <p class="title">{{item.title}}</p>
                            <div class="msg">
                                <p>{{item.msg}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item-card jd">
            <div class="page-module animated fadeInUp">
                <p class="name">企业发展阶段</p>
                <ul>
                    <li v-for="(item, index) in cardThree" :key="index">
                        <div :class="{'card': true, 'active': activeCardThree == item.innerid}" @click="activeCardThree = item.innerid">
                            <img :src="item.img" alt="icon">
                            <p class="title">{{item.title}}</p>
                            <div class="msg">
                                <p>{{item.twoLeverTitle}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-module btn animated fadeInUp">
            <el-button @click="nextStep" type="primary">下一步</el-button>
        </div>
</div>
</template>

<script>
import {getEvArithmetic} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'StepOne',
    data() {
        return {
            cardOne: [{innerid: '1', title: "股权激励", twoLeverTitle: "Equity incentive", img: require('@/common/images/gujing/gz/icon-step-1.png'), msg: "企业为了激励和留住核心人才而推行的一种长期激励机制，是目前最常用的激励员工的方法之一。"},
                      {innerid: '2', title: "股权融资", twoLeverTitle: "Equity financing", img: require('@/common/images/gujing/gz/icon-step-2.png'), msg: "企业的股东愿意让出部分企业所有权，通过企业增资的方式引进新的股东，同时使总股本增加的融资方式。"},
                      {innerid: '3', title: "企业并购", twoLeverTitle: "Merger  & Acquisition", img: require('@/common/images/gujing/gz/icon-step-3.png'), msg: "企业之间的兼并与收购行为，是企业法人在平等自愿、等价有偿基础上，以一定的经济方式取得其他法人产权的行为，是企业进行资本运作和经营的一种主要形式。企业并购主要包括公司合并、资产收购、股权收购三种形式。"}],
            cardTwo: [{innerid: '1', title: "互联网新经济",  img: require('@/common/images/gujing/gz/icon-step-4.png'), msg: "基于互联网所产生的经济活动的总和，信息网络化时代产生的一种崭新的经济现象。"},
                        {innerid: '2', title: "重资产", img: require('@/common/images/gujing/gz/icon-step-5.png'), msg: "指企业所持有的例如厂房原材料等有形的资产"},
                        {innerid: '3', title: "轻资产", img: require('@/common/images/gujing/gz/icon-step-6.png'), msg: "指企业紧紧抓住自己的核心业务，而将非核心业务外包出去。"}],
            cardThree: [{innerid: '1', title: "初创期", twoLeverTitle: "Initial stage", img: require('@/common/images/gujing/gz/icon-step-7.png')},
                        {innerid: '2', title: "成长期", twoLeverTitle: "Growing period", img: require('@/common/images/gujing/gz/icon-step-8.png')},
                        {innerid: '3', title: "成熟期", twoLeverTitle: "Mature period", img: require('@/common/images/gujing/gz/icon-step-9.png')}],
            activeCardOne: '',  // 企业估值用途  选中列表
            activeCardTwo: '',  // 企业所属行业  选中列表
            activeCardThree: '',  // 企业发展阶段   选中列表
        }
    },
    mounted() {
        $('html').scrollTop(0)
    },
    methods: {
        // 选择企业估值用途
        selectActiveCardOne(val) {
            this.activeCardOne = val
            this.goTop(500)
        },
        // 选择企业所属行业
        selectActiveCardTwo(val) {
            this.activeCardTwo = val
            this.goTop(1000)
        },
        // 回到距离顶部位置
        goTop(val) {
            $('html,body').animate({
                scrollTop: val
            }, 300)
        },
        // 下一步
        nextStep() {
            if (this.activeCardOne === '') {
                this.$message.warning('请选择企业估值用途')
                this.goTop(100)
            } else if (this.activeCardTwo === '') {
                this.$message.warning('请选择企业所属行业')
                this.goTop(480)
            } else if (this.activeCardThree === '') {
                this.$message.warning('请选择企业发展阶段')
            } else {
                this.findEvArithmetic()
            }
            // this.$emit('setStepValue', 1)
        },
        findEvArithmetic() {
            this.setLoading(true)
            let params = {
                evuseagetype: this.activeCardOne,
                evindustrytype: this.activeCardTwo,
                evphasetype: this.activeCardThree
            }
            getEvArithmetic({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    if (data) {
                        this.$emit('setStepData', data.data.content, params)
                        this.$emit('setStepValue', 1)
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepOne {
    .bg-F5F7FA {
        background: #F5F7FA;
    }
    .page-module {
        overflow: inherit;
    }
    .item-card {
        clear: both;
        height: 500px;
        // position: relative;
        padding-top: 30px;
        padding-bottom: 73px;
        box-sizing: border-box;
        .name {
            position: relative;
            margin-bottom: 63px;
            text-align: center;
            font-size: 22px;
            &::before {
                content: '';
                position: absolute;
                display: block;
                margin: auto;
                left: 0;
                right: 0;
                bottom: -10px;
                width:38px;
                height:2px;
                background: #409EFF;
            }
        }
        ul > li {
            float: left;
            position: relative;
            width: 360px;
            height: 310px;

            .card {
                position: relative;
                left: 0;
                top: 0;
                width: 360px;
                height: 310px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -webkit-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -moz-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -ms-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -o-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                cursor: pointer;
                border-radius: 7px;
                transition: all .5s;
                -webkit-transition: all .5s;
                -ms-transition: all .5s;
                -o-transition: all .5s;
                -moz-transition: all .5s;
                box-sizing: border-box;
                border: solid 1px rgba(0,0,0,0.15);

                &:hover,
                &.active {
                    position: absolute;
                    left: -5px;
                    top: -5px;
                    width: 370px;
                    height: 320px;
                    border: solid 1px #409EFF;
                    
                    &,
                    .title {
                        transition: all .5s;
                        -webkit-transition: all .5s;
                        -ms-transition: all .5s;
                        -o-transition: all .5s;
                        -moz-transition: all .5s;
                    }
                    
                    .title {
                        color: #409EFF;
                    }
                }
               
                .head {
                    position: relative;
                    padding: 20px;
                    box-sizing: border-box;
                    height:120px;
                    background:linear-gradient(90deg,rgba(56,181,255,1) 0%,rgba(51,113,255,1) 100%);
                    background: -webkit-linear-gradient(90deg,rgba(56,181,255,1) 0%,rgba(51,113,255,1) 100%);
                    background: -ms-linear-gradient(90deg,rgba(56,181,255,1) 0%,rgba(51,113,255,1) 100%);
                    background: -moz-linear-gradient(90deg,rgba(56,181,255,1) 0%,rgba(51,113,255,1) 100%);
                    background: -o-linear-gradient(90deg,rgba(56,181,255,1) 0%,rgba(51,113,255,1) 100%);
                    border-radius:6px 6px 0px 0px;
                    p {
                        color: #fff;
                        font-size: 22px;
                        &~p {
                            margin-top: 12px;
                            font-size: 18px;
                        }
                    }
                    img {
                        position: absolute;
                        top: 10px;
                        right: 20px;
                        height: 85px;
                    }
                }
                .msg {
                    margin: auto;
                    margin-top: 10px;
                    width: 320px;
                    line-height: 20px;
                }
                &.active::before {
                    content: '';
                    opacity: 1;
                }
                &::before {
                    content: '';
                    position: absolute;
                    z-index: 1;
                    display: block;
                    right: 20px;
                    top: 20px;
                    width: 30px;
                    height: 30px;
                    background-image: url('../../../../common/images/gujing/gz/icon-step-radio1.png');
                    background-size: 30px 30px;
                    background-repeat: no-repeat;
                    background-position: center;
                    transition: all .5s;
                    -webkit-transition: all .5s;
                    -ms-transition: all .5s;
                    -o-transition: all .5s;
                    -moz-transition: all .5s;
                    opacity: 0;
                }
            }
            & ~ li {
                margin-left: 40px;
            }
        }
        &.hy,
        &.jd {
            p {
                text-align: center;
            }
            img {
                margin: auto;
            }
            .title {
                margin: 20px 0;
                font-size: 22px;
            }

            .card {
                &::before  {
                    background-image: url('../../../../common/images/gujing/gz/icon-step-radio2.png');
                }
            }
        }
        &.hy {
           
            img {
                width: 120px;
                height: 120px;
            }
            .card {
                 padding: 30px 20px;
                 box-sizing: border-box;
            }
        }
        &.jd {
            img {
                width: 113px;
                height: 75px;
            }
            .card {
                 padding: 60px 20px;
                 box-sizing: border-box;
                .title {
                    margin: 24px 0 16px 0;
                    font-size: 22px;
                }
                .msg {
                    font-size: 22px;
                    color: #999999;
                }
            }
            
        }
    }
    .btn {
        text-align: center;
        .el-button {
            width:180px;
            height:40px;
            border-radius:6px;
        }
    }
}
</style>